import { Box, Flex } from '@chakra-ui/react';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { ApiForecast } from 'src/api/queries';
import { FORECAST_COLUMNS } from './columns';

type ForecastRowProps = {
  forecast: ApiForecast;
  isExpanded: boolean;
};

export const ForecastRow: React.FC<ForecastRowProps> = ({
  forecast,
  isExpanded,
}) => {
  return (
    <Flex
      textAlign={{ lg: 'right', xl: 'left' }}
      overflowWrap="anywhere"
      flex={1}
      flexDir="row"
      wrap="nowrap"
      minW="fit-content">
      {FORECAST_COLUMNS.map((col) => (
        <Box
          key={col.key}
          width={col.width}
          minW={col.minW}
          p={4}
          fontSize={{ md: 'xs', lg: 'sm' }}
          fontFamily="marketingPage"
          color="content.title"
          textAlign={col.isNameColumn ? 'left' : { lg: 'right', xl: 'left' }}>
          {col.isNameColumn && (
            <ChakraIcon
              as={isExpanded ? ChevronDown : ChevronRight}
              boxSize={4}
              mr={2}
              display="inline-block"
              verticalAlign="middle"
              w={4}
              minW={4}
            />
          )}
          {col.render(forecast)}
        </Box>
      ))}
    </Flex>
  );
};
